// src/utils/loaders.js
//
// Themed drop-ins for Notiflix Block / Loading / Report (audit 4.2 / 7.5).
// Same call signatures the app already uses, rendered with the shared
// ee-ui.css look (ring spinner, tokens) instead of Notiflix factory defaults.
//   Block.standard(".page-loading");  Block.remove(".page-loading");
//   Loading.standard("Exporting data");  Loading.remove();
//   Report.warning(title, message, buttonLabel);
import { dialog } from "./dialog";

const BLOCK_ATTR = "data-ee-block";

export const Block = {
  standard(selector) {
    try {
      document.querySelectorAll(selector).forEach((host) => {
        if (host.querySelector(`:scope > [${BLOCK_ATTR}]`)) return;
        host.classList.add("ee-block-host");
        const layer = document.createElement("div");
        layer.className = "ee-block";
        layer.setAttribute(BLOCK_ATTR, "");
        layer.setAttribute("role", "status");
        layer.setAttribute("aria-label", "Loading");
        const ring = document.createElement("span");
        ring.className = "ee-spinner";
        layer.appendChild(ring);
        host.appendChild(layer);
      });
    } catch (e) {}
  },
  remove(selector) {
    try {
      const hosts = selector ? document.querySelectorAll(selector) : document.querySelectorAll(".ee-block-host");
      hosts.forEach((host) => {
        host.querySelectorAll(`:scope > [${BLOCK_ATTR}]`).forEach((n) => n.remove());
      });
    } catch (e) {}
  },
};

let overlay = null;
export const Loading = {
  standard(message) {
    try {
      Loading.remove();
      overlay = document.createElement("div");
      overlay.className = "ee-loading-overlay";
      overlay.setAttribute("role", "status");
      const ring = document.createElement("span");
      ring.className = "ee-spinner";
      overlay.appendChild(ring);
      if (message) {
        const t = document.createElement("span");
        t.textContent = String(message).replace(/\.{3}$/, "");
        overlay.appendChild(t);
      }
      document.body.appendChild(overlay);
    } catch (e) {}
  },
  remove() {
    try {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    } catch (e) {}
    overlay = null;
  },
};

const report = (tone) => (title, message, buttonLabel, cb) =>
  dialog.alert({ title, message, confirmLabel: buttonLabel || "OK", tone }).then(() => {
    if (typeof cb === "function") cb();
  });

export const Report = {
  success: report("success"),
  info: report("primary"),
  warning: report("warning"),
  failure: report("danger"),
};
